import Vue from "vue/dist/vue.esm.js";
import Notifications   from 'vue-notification'
import superagent from "superagent";
import { Modal } from "bootstrap";

Vue.use(Notifications)

const token = document
  .getElementsByName("csrf-token")[0]
  .getAttribute("content");

window.onload = function () {
  window.mv = new Vue({
    el: "#mv",
    mixins: [],
    data: {
      customer: {
        condition: false,
        year: "",
        distance: ""
      },
      distanceLabel: null,
      conditions: [],
      brands: [],
      cars: [],
      prefectures: [],
      car_mileages: [],
      year_options: [],
      brand: "",
      car: "",
      conditionLabel: null,
      brandValue: false,
      prefectureLabel: "",
      yearLabel: null,
      carMileageLabel: null,
      searchBrands: "",
      searchCars: "",
      state: "conditions",
      modalVisible: false,
      jaAlpha: [
        ["ア", "イ", "ウ", "エ", "オ"],
        ["カ", "キ", "ク", "ケ", "コ"],
        ["サ", "シ", "ス", "セ", "ソ"],
        ["タ", "チ", "ツ", "テ", "ト"],
        ["ナ", "ニ", "ヌ", "ネ", "ノ"],
        ["ハ", "ヒ", "フ", "ヘ", "ホ"],
        ["マ", "ミ", "ム", "メ", "モ"],
        ["ヤ", "ユ", "ヨ"],
        ["ラ", "リ", "ル", "レ", "ロ"],
        ["ワ", "ヲ", "ン"],
      ],
      errors: [],
      loading: false,
      isClickedSubmitBtn: false,
    },
    created() {
      this.fetchConditions();
    },
    mounted() {
    },
    computed: {
      filterdBrands() {
        if (!this.searchBrands) {
          return this.brands;
        }
        return this.brands.filter((brand) =>
          brand.title.toLowerCase().includes(this.searchBrands.toLowerCase())
        );
      },
      navConditionClass() {
        if(this.customer.condition) {
          return "modal-nav-list-selected"
        } else if (this.state == "conditions") {
          return "modal-nav-list-now"
        } else {
          return ""
        }
      },
      navBrandClass() {
        if(this.brand) {
          return "modal-nav-list-selected"
        } else if (this.state == "brands") {
          return "modal-nav-list-now"
        } else {
          return ""
        }
      },
      navCarClass() {
        if(this.car) {
          return "modal-nav-list-selected"
        } else if (this.state == "cars") {
          return "modal-nav-list-now"
        } else {
          return ""
        }
      },
      // navYearClass() {
      //   if (this.customer.year) {
      //     return "modal-nav-list-selected"
      //   } else if(this.state == "years") {
      //     return "modal-nav-list-now"
      //   } else {
      //     return ""
      //   }
      // },
      // navDistanceClass() {
      //   if (this.customer.distance) {
      //     return "modal-nav-list-selected"
      //   } else if(this.state == "distances" ) {
      //     return "modal-nav-list-now"
      //   } else {
      //     return ""
      //   }
      // }
      navSubmitClass() {
        if (this.state == "submit") {
          return "modal-nav-list-now"
        } else {
          return ""
        }
      },
    },
    methods: {
      initialization(){
        this.fetchBrands();
        this.fetchPrefectures();
        this.fetchYearOptions();
        this.fetchCarMileages();
        this.loading = true
      },
      filled(){
        if(!this.car){
          return false
        }
        if(!this.brand){
          return false
        }
        if(!this.customer.condition){
          return false
        }
        return true
      },
      canSubmit(){
        if(this.customer.condition && this.brand.id && this.car.id && this.customer.tel && this.customer.name && this.customer.pref){
          return true
        } else {
          return false
        }
      },
      submit() {
        if (this.isClickedSubmitBtn) return
        this.isClickedSubmitBtn = true
        if (!this.customer.condition) {
          this.errors.push('状態を入力してください');
        }
        if (!this.car) {
          this.errors.push('車種を入力してください');
        }
        if (!this.customer.tel){
          this.errors.push('電話番号を入力してください');
        }
        if (!this.customer.name){
          this.errors.push('名前を入力してください');
        }
        if (!this.customer.pref){
          this.errors.push('都道府県を入力してください');
        }

        if (this.errors.length) {
          for (let i = 0;  i < this.errors.length;  i++ ) {
            Vue.notify({
              group: 'information',
              type: 'error',
              title: this.errors[i],
              text: '',
            })
          }
          this.errors = []
          this.isClickedSubmitBtn = false
          return
        }

        const params = {
          customer: {
            name: this.customer.name,
            tel1: this.customer.tel,
            pref: this.customer.pref,
            item_attributes: {
              condition: this.customer.condition,
              distance: this.customer.distance,
              year:     this.customer.year,
              car_id:   this.car.id
            }
          }
        }
        superagent
          .post("/api/v1/estimates")
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .send(params)
          .end((error, data) => {
            if(data.status == 200 || data.status == 201){
              location.href = "/complete?id=" + data.body.id
            } else {
              this.isClickedSubmitBtn = false
            }
          });
      },
      fetchConditions() {
        superagent
          .get("/api/v1/conditions.json")
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.conditions = data.body;
          });
      },
      fetchBrands() {
        superagent
          .get("/api/v1/brands.json")
          .query({ title: this.searchBrands })
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.brands = data.body;
          });
      },
      fetchCars() {
        superagent
          .get("/api/v1/brands/" + this.brand.id + "/cars.json")
          .query({ title: this.searchCars })
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.cars = data.body;
            this.cars.sort((a, b) => {
              const nameA = a.title.normalize("NFC");
              const nameB = b.title.normalize("NFC");
              return nameA.localeCompare(nameB, "ja");
            });
            this.state = "cars";
          });
      },
      fetchPrefectures() {
        superagent
          .get("/api/v1/prefectures.json")
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.prefectures = data.body;
            var mvEl = document.getElementById("mv");
            var defaultPrefId = mvEl && mvEl.dataset.defaultPrefectureId;
            var defaultPrefTitle = mvEl && mvEl.dataset.defaultPrefectureTitle;
            if (defaultPrefId && !this.customer.pref) {
              this.customer.pref = parseInt(defaultPrefId);
              this.prefectureLabel = defaultPrefTitle;
            }
          });
      },
      fetchYearOptions() {
        superagent
          .get("/api/v1/year_options.json")
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.year_options = data.body;
          });
      },
      fetchCarMileages() {
        superagent
          .get("/api/v1/car_mileages.json")
          .set("X-CSRF-Token", token)
          .set("Accept", "application/json")
          .end((error, data) => {
            this.car_mileages = data.body;
          });
      },
      clickCloseModal(){
        this.$refs.mvModal.style.display = 'none';
      },
      clickOpenModal(state) {
        if(!this.loading){
          this.initialization()
        }
        this.state = state
        this.$refs.mvModal.style.display = 'block';
      },
      clickOpenModalCar() {
        if(this.brand != ""){
          this.state = 'cars'
        } else if(this.customer.condition != false){
          this.state = 'brands'
        } else {
          this.state = "conditions"
          if(!this.loading){
            this.initialization()
          }
        }
        this.$refs.mvModal.style.display = 'block';
      },
      clickOpenModalSubmit() {
        if(this.car != "" && this.brand != "" && this.customer.condition != false){
          this.state = 'submit'
        } else if(this.brand != ""){
          this.state = 'cars'
        } else if(this.customer.condition != false){
          this.state = 'brands'
        } else {
          this.state = "conditions"
          if(!this.loading){
            this.initialization()
          }
        }
        this.$refs.mvModal.style.display = 'block';
      },
      clickCondition(condition) {
        this.customer.condition = condition.value
        this.conditionLabel = condition.label
        this.state = "brands"
      },
      clickBrand(brand) {
        this.brand = brand;
        this.car = ""
        this.fetchCars();
        this.state = "cars";
      },
      clickCar(car) {
        this.car = car;
        this.brandValue = this.brand.id;
        this.state = "submit"
      },
      changePrefecture(prefectureValue){
        this.prefectureLabel = this.prefectures.find((pref) => pref.id == prefectureValue).title;
      },
      changeYear(yearValue){
        this.yearLabel = this.year_options.find((year) => year.value == yearValue).label;
      },
      changeDistance(distanceValue){
        this.distanceLabel = this.car_mileages.find((mileage) => mileage.value == distanceValue).label;
      },
      // clickYear(year) {
      //   this.customer.year = year.value
      //   this.yearLabel = year.label
      //   this.state = 'distances'
      // },
      // clickCarMileage(car_mileage) {
      //   this.customer.distance = car_mileage.value
      //   this.carMileageLabel =  car_mileage.label
      //   this.mvModal.hide();
      // },
      clickNavCondition(){
        this.state = 'conditions'
      },
      clickNavBrand(){
        if(this.customer.condition != false){
          this.state = 'brands'
        }
      },
      clickNavCar(){
        if(this.brand != ""){
          this.state = 'cars'
        }
      },
      clickNavSubmit(){
        if(this.car != "" && this.brand != "" && this.customer.condition != false){
          this.state = 'submit'
        }
      },
      clickStep3(){
        if(this.customer.year != false){
          this.state = 'years'
        }
      },
      clickStep4(){
        if(this.customer.distance != false){
          this.state = 'distances'
        }
      },
      carsSearchByTitle(array) {
        return this.cars.filter((element) => {
          return array.some((searchItem) => {
            return element.title.normalize("NFD")[0].indexOf(searchItem) === 0;
          });
        });
      },
      enMaCars() {
        // アルファベットなどで始まる車種
        return this.cars.filter((element) => {
          const firstChar = element.title.charAt(0);
          return /^[a-zA-Z0-9]/.test(firstChar);
        });
      },
      otherCars() {
        // その他の車種
        const array = this.jaAlpha.reduce((acc, group) => {
          return acc.concat(group);
        }, []);

        const returnArray = this.cars.filter(
          (element) =>
            !array.some(
              (searchItem) =>
                element.title.normalize("NFD")[0].indexOf(searchItem) === 0
            )
        );

        return returnArray.filter((element) => {
          const firstChar = element.title.charAt(0);
          if (/^[a-zA-Z0-9]/.test(firstChar)) {
            return false;
          } else {
            return true;
          }
        });
      },
      validTel() {
        // 10文字から11文字の数字のみ
        return /^[0-9]{10,11}$/.test(this.customer.tel);
      },
      scrollToElement(target) {
        const targetElement = document.querySelector(`#${target}`);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      },
    },
  });
};
